import { apiClient } from "@/lib/api-client";
import type { Account } from "@/features/auth/types";

export const authApi = {
  register: (email: string, password: string) =>
    apiClient.post<Account>("/v1/accounts", { email, password }),
  login: (email: string, password: string) =>
    apiClient.post<Account>("/v1/auth/login", { email, password }),
  requestPasswordReset: (email: string) =>
    apiClient.post<void>("/v1/auth/password-reset/request", { email }),
  confirmPasswordReset: (token: string, newPassword: string) =>
    apiClient.post<void>("/v1/auth/password-reset/confirm", { token, newPassword }),
};
